import { EventMeta } from '../../../interfaces/meta.interface';

const updateFolderPermissions: EventMeta = {
    title: 'Update Folder Permissions',
    default: {
        description: 'Update Folder Permissions',
        longDescription:
            'A folder permission was changed. Folder permissions control which users in your organization can access folders in a mailbox and the messages located in those folders.',
        severity: 'info',
    },
};

export default updateFolderPermissions;
